export enum OrderRecipientAction {
  ReviewDocuments = 'ReviewDocuments',
  SignDocuments = 'SignDocuments',
  ReceiveACopy = 'ReceiveACopy',
}
